import { render, staticRenderFns } from "./TermsModal.vue?vue&type=template&id=f96dc6f4&scoped=true&"
import script from "./TermsModal.vue?vue&type=script&lang=js&"
export * from "./TermsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsModal.vue?vue&type=style&index=0&id=f96dc6f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96dc6f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VDialog,VImg})
